import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup } from "../../store/popupSlice"
import Breadcrumb from "../../component/Breadcrumb";

const breadcrumbData = {
  newClass: "center-breadcrumb white-breadcrumb",
  list: [
    {
      page: "Home",
      slug: "/"
    },
    {
      page: "Bike Rental",
      slug: ""
    },
  ]
}
export default function BRHead({ featureId }) {

  const dispatch = useDispatch();

  return (
    <>
      <section className="bike-Rental-head header-gap">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="bike-rental-head-wrap text-center wow animate__animated animate__slideInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                <Breadcrumb breadcrumbData={breadcrumbData} />
                <h1 className="heading">Create Your Own <br />
                  Bike-Sharing Solution</h1>
                <p className="sub-heading">Launch and scale a customizable bike-sharing system, whether it's a free-floating or station-based model. Our advanced platform adapts seamlessly to your business objectives, ensuring operational efficiency and standing out with superior technology over competitors.</p>
                <small>21 Days Free Trial | No Credit Card Required</small>
                <Link style={{ marginRight: "10px" }} onClick={() => dispatch(openPopup())} className="default-btn default-white">Request a Demo</Link>
                <Link style={{ marginLeft: "10px" }} to={`/features/${featureId}`} className="default-btn default-white">
                  Explore Features
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
